let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kXqCi")).then(() => parcelRequire('2ciBJ'));